// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"SsoLogin_loadingWrapper__ASk1f","loader":"SsoLogin_loader__fZ2Z8","goBack":"SsoLogin_goBack__EgVuD"};